import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";

const TimeRangeOverlay: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [options, setOptions] = useState({
    automationauges: true,
    manualgauges: true,
    selectAll: true,
  });

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setOptions((prevOptions) => ({
      ...prevOptions,
      [name]: checked,
      selectAll: name === "selectAll" ? checked : prevOptions.selectAll,
      ...(name === "selectAll" && {
        automationauges: checked,
        manualgauges: checked,
      }),
    }));
  };

  const handleOptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setOptions((prevOptions) => {
      const newOptions = { ...prevOptions, [name]: checked };
      const allSelected = newOptions.automationauges && newOptions.manualgauges;
      return { ...newOptions, selectAll: allSelected };
    });
  };

  return (
    <div
      style={{
        position: "absolute",
        right: "10px",
        top: "150px",
        transform: "translateY(-50%)",
        backgroundColor: "rgba(85, 84, 95, 1)",
        padding: "10px",
        borderRadius: "5px",
        width: "200px",
        height: "150px",
        zIndex: "999",
      }}
    >
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            color: "white",
            fontSize: "18px",
          }}
        >
          Sensor Type
        </div>
        <div
          style={{ width: "20%", display: "flex", justifyContent: "flex-end" }}
        >
          <FontAwesomeIcon
            onClick={onClose}
            onTouchStart={onClose}
            style={{
              cursor: "pointer",
              color: "red",
              border: "3px solid #dc143c",
              borderRadius: "50%",
              width: "15px",
              height: "15px",
            }}
            icon={faClose}
          />
        </div>
      </div>
      <div
        style={{
          height: "50%",
          display: "flex",
          flexDirection: "column",
          borderRadius: "2px",
          padding: "5px",
        }}
      >
        <FormGroup style={{ color: "white", fontSize: "9px" }}>
          <FormControlLabel
            control={
              <Checkbox
                defaultChecked={true}
                name="selectAll"
                checked={options.selectAll}
                onChange={handleCheckboxChange}
                sx={{
                  color: "white",
                  "&.Mui-checked": { color: "white" },
                }}
              />
            }
            label={<span style={{}}>All</span>}
            sx={{ width: "100%" }}
          />
          <FormControlLabel
            control={
              <Checkbox
                name="automationauges"
                checked={options.automationauges}
                onChange={handleOptionChange}
                sx={{
                  color: "white",
                  "&.Mui-checked": { color: "white" },
                }}
              />
            }
            label="Automation Gauges"
            sx={{ width: "100%" }}
          />
          <FormControlLabel
            control={
              <Checkbox
                name="manualgauges"
                checked={options.manualgauges}
                onChange={handleOptionChange}
                sx={{
                  color: "white",
                  "&.Mui-checked": { color: "white" },
                }}
              />
            }
            label="Manual Gauges"
            sx={{ width: "100%" }}
          />
        </FormGroup>
      </div>
    </div>
  );
};

export default TimeRangeOverlay;
